import BaseAPIClient from "../base/BaseAPIClient";
import moment from 'moment';

export default class WorkshopReportsClient extends BaseAPIClient {

  getWorkshops({pageToken}) {
    return this._get('v2/campus-administration/reports/workshops/list/', {
      pageToken
    });
  }
}